import { TextField, MenuItem } from "@mui/material";

export const FormSelectInput = ({
  formik,
  name,
  label,
  options,
  isDisabled,
  onChange,
}) => {
  const error = formik.touched[name] && Boolean(formik.errors[name]);

  return (
    <TextField
      select
      fullWidth
      size="small"
      name={name}
      label={label}
      value={formik.values[name] || ""}
      onChange={onChange ?? formik.handleChange}
      onBlur={formik.handleBlur}
      disabled={isDisabled}
      error={error}
      helperText={formik.touched[name] && formik.errors[name]}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
